import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';

const templateUrl = require('./userRoleDetail.html');

class UserRoleDetailController extends ComponentController {
  currentSite: any;
  userRole: any;
  manufacturers: any[];
  sites: any[];
  users: any[];
  roles: any[];
  groupType: string;
  canDelete: boolean;
  canEditUser: boolean;

  constructor(
    private $state: any,
    private $stateParams: any,
    private UserRoleService: any,
    private RoleService: any,
    private AuthService: any,
    private uibModal: any
  ) {
    super();
  }

  $onInit = () => {
    if (this.$stateParams.userId) {
      this.userRole.user = _.find(this.users, { id: this.$stateParams.userId });
    }

    if (this.$stateParams.siteId) {
      this.userRole.group = { id: this.$stateParams.siteId, type: 'sites' };
    } else if (this.userRole.group && !this.userRole.group.id) {
      this.userRole.group = null;
    }

    this.groupType = _.get(this.userRole.group, 'type', 'sites');

    if (this.userRole.role && !this.userRole.role.id) {
      this.userRole.role = null;
    }

    this.canDelete = this.userRole.id && this.AuthService.hasPermission('UserRole', 'delete');
    this.canEditUser = this.userRole.id && this.userRole.user.id;
    this.updateRoles();
  };

  updateRoles = () => {
    this.roles = [];

    if (!this.userRole.group || !this.userRole.group.id) return;
    let criteria = null;

    if (this.userRole.group.type === 'sites') {
      criteria = { site: this.userRole.group.id };
    } else if (this.userRole.group.type === 'chemical-manufacturers') {
      criteria = { chemical_manufacturer: this.userRole.group.id };
    } else {
      return;
    }

    this.RoleService.getAll(criteria).then(roles => {
      this.roles = roles;
    });
  };

  saveUserRole = isValid => {
    if (isValid) {
      this.UserRoleService.save(this.userRole).then(() => {
        this.goToUser();
      });
    }
  };

  deleteResource = () => {
    this.UserRoleService.delete(this.userRole).then(() => {
      this.goToUser();
    });
  };

  goToUser = () => {
    let userId = _.get(this.userRole, 'user.id');
    if (userId) {
      this.$state.go('admin.user-detail', { userId: userId });
    } else {
      this.$state.go('admin.users');
    }
  };

  confirmDelete = () => {
    this._confirmDelete(this.uibModal, this.userRole, this.userRole.role.name);
  };
}

angular.module('ciApp').component('userRoleDetail', {
  templateUrl: templateUrl,
  bindings: {
    currentSite: '<',
    userRole: '<',
    sites: '<',
    manufacturers: '<',
    users: '<'
  },
  controller: [
    '$state',
    '$stateParams',
    'UserRoleService',
    'RoleService',
    'AuthService',
    '$uibModal',
    UserRoleDetailController
  ]
});



// WEBPACK FOOTER //
// ./app/admin/user-roles/userRoleDetail.component.ts